import { Component } from '@angular/core';
import { HeaderComponent } from '@shared/components/header/header.component';
import { TranslatePipe } from '@ngx-translate/core';
import { NavItem } from '@shared/interfaces/nav/nav-item';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-settlement-detail',
  imports: [
    HeaderComponent,
    TranslatePipe,
    RouterOutlet
  ],
  templateUrl: './settlement-detail.component.html',
  styleUrl: './settlement-detail.component.css'
})
export class SettlementDetailComponent {

  public navItems: NavItem[] = [
    {
      title: 'settlement.metered.title',
      route: '/settlement',
    },
    {
      title: 'settlement.wholesale.title',
      route: '/settlement/wholesale',
    },
    {
      title: 'settlement.billing.title',
      route: '/settlement/billing',
    },
  ];

}
